
import React ,{useEffect, useState} from 'react';

const CalendarGrid = ({ totalDays, startDay, actualDate, actualMonth, actualYear, onDayClick, setInProgress }) => {
  const today = new Date();
  const grid = [];
  const [animate, setAnimate] = useState(false);
  const DAY_BLOCKED = 2;
  for (let i = 0; i < startDay; i++) {
    grid.push(<div key={`empty-${i}`} />);
  }
  useEffect(() => {
    setAnimate(false);
    setTimeout(() => setAnimate(true), 10);
  }, [actualMonth, actualYear]);

  useEffect(() => {
    setInProgress(false)
  },[])
  
  for (let day = 1; day <= totalDays; day++) {
    const isToday =
      day === today.getDate() &&
      actualMonth === today.getMonth() &&
      actualYear === today.getFullYear();
    const currentDate = new Date(actualYear, actualMonth, day);
    currentDate.setHours(0, 0, 0, 0);
    const minDate = new Date();
    minDate.setDate(minDate.getDate() + DAY_BLOCKED);
    minDate.setHours(0, 0, 0, 0);
    const isSunday = currentDate.getDay() === 0;
    const isBlocked = currentDate <= minDate;

    grid.push(
      <div
        key={day}
        className={`day ${isToday ? 'today' : ''} ${!isToday? isSunday || isBlocked ? 'deactivated' : 'anyday': null}`}
        onClick={() => !isSunday && !isBlocked && onDayClick(day)}
      >
        {day}
      </div>
    );
  }

  // const animationKey = `${actualMonth}-${actualYear}`;
  // key={animationKey} className={animate ? 'animate-opacity' : ''}

  return <div id="calendar-grid" >{grid}</div>;
};

export default CalendarGrid;